import { Greeting } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchGreeting } from './GreetingSlice';
import { GreetingDataSelector } from './GreetingDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useGreeting(): AbstractDataState<Greeting, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchGreeting, GreetingDataSelector);
}
